import { useContext, useEffect, useState } from 'react';
import { AnalysisCarousel } from './AnalysisCarousel';
import { AnalysisCarouselSpeaker } from './AnalysisCarouselSpeaker';
import { KlartextEventConfigContext } from '../providers/klartextEventConfig';
import { useLocation } from 'react-router-dom';
import IsRecordingMarquee from './IsRecordingMarquee';
import NotStartedView from './NotStartedView';
import { useCountdown } from '../hooks/use-countdown';
import { isRecording } from '../utils/elapsedTime';

interface SpeechAnalysisProps {
  onLoad: (eventId: string | null) => void;
}

export const SpeechAnalysis = ({ onLoad }: SpeechAnalysisProps) => {
  const klartextEventConfig = useContext(KlartextEventConfigContext);
  const [klartextEventConfigId, setklartextEventConfigId] = useState<string | null>(null);
  const { pathname } = useLocation();

  const countdown = useCountdown(klartextEventConfig?.eventStartTime ?? '');

  useEffect(() => {
    if (pathname !== '/') {
      const eventId = pathname.split('/')[1];
      setklartextEventConfigId(eventId);
      onLoad(eventId);
    } else {
      setklartextEventConfigId(null);
      onLoad(null);
    }
  }, [onLoad, pathname]);

  const hasStarted = !!klartextEventConfig && new Date(klartextEventConfig.eventStartTime).getTime() < Date.now();
  const recording = isRecording(klartextEventConfig);

  return (
    <>
      <div className="relative mx-auto flex h-fallback-screen flex-col lg:max-w-2xl">
        <AnalysisCarouselSpeaker />
        {recording && <IsRecordingMarquee />}
        {klartextEventConfig && klartextEventConfig.eventId === klartextEventConfigId && (
          <main className="block max-h-full flex-grow">
            {hasStarted ? <AnalysisCarousel /> : <NotStartedView countdown={countdown} />}
          </main>
        )}
      </div>
    </>
  );
};
